import useStore from 'reusable/mobx-store-utils'
import { observer } from 'mobx-react-lite'
import React from 'react'
import CacheStore, { CacheStoreProvider } from './CacheStore'
import { useWebSocketStore } from 'websockets/WebSocketStore'
import { useOrgGuardStore } from 'features/main/main-router/org-guard/OrgGuardStore'
import useInitialMount from 'reusable/hooks/useInitialMount'
import { PlatformContainer } from 'reusable/containers/PlatformContainer'
import AdvisorBlueprintCacheStore from './AdvisorBlueprintCacheStore'
import ClientsCacheStore from './ClientsCacheStore'
import ProcessCacheStore from './ProcessCacheStore'

export default observer(function CacheProvider(props: { children?: React.ReactNode }) {
   const webSocketStore = useWebSocketStore()
   const orgGuardStore = useOrgGuardStore()
   const advisorBlueprintCacheStore = useStore(sp => new AdvisorBlueprintCacheStore(sp), { orgGuardStore })
   const clientsCacheStore = useStore(sp => new ClientsCacheStore(sp), { orgGuardStore })
   const processCacheStore = useStore(sp => new ProcessCacheStore(sp), { orgGuardStore })
   const cacheStore = useStore((sp) => new CacheStore(sp), { webSocketStore, orgGuardStore, advisorBlueprintCacheStore, clientsCacheStore, processCacheStore })

   useInitialMount(cacheStore.fetch)

   if (!cacheStore.hasLoaded) {
      return <PlatformContainer loadingMessage="Loading organisation" loading={true} contentCentered={true} />
   }

   return (
      <CacheStoreProvider store={cacheStore}>
         {props.children}
      </CacheStoreProvider>
   )
})
